export default "__VITE_ASSET__1a511ea1__"